var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canLoad
    ? _c("div", { staticClass: "form-group position-relative" }, [
        _vm.label
          ? _c("label", { staticClass: "font-size-12" }, [
              _vm._v(_vm._s(_vm.label)),
            ])
          : _vm._e(),
        _c("div", { staticClass: "input-container d-flex" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.iValue,
                expression: "iValue",
              },
            ],
            staticClass: "form-control",
            style: { flex: "1 1 auto" },
            attrs: {
              disabled: !!(
                _vm.loadingUpload ||
                _vm.loadingImages ||
                _vm.loadingMoreImages
              ),
              type: "text",
              placeholder: "https://example.com",
            },
            domProps: { value: _vm.iValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.iValue = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn-upload",
              attrs: {
                disabled: !!(
                  _vm.loadingUpload ||
                  _vm.loadingImages ||
                  _vm.loadingMoreImages
                ),
                title: "Upload",
              },
              on: { click: _vm.selectFile },
            },
            [
              _vm.loadingUpload
                ? _c("b-spinner", { attrs: { small: "" } })
                : _c("i", { class: _vm.uploadIcon }),
            ],
            1
          ),
          _vm.splashImage
            ? _c(
                "button",
                {
                  staticClass: "btn-upload",
                  attrs: {
                    disabled: !!(
                      _vm.loadingUpload ||
                      _vm.loadingImages ||
                      _vm.loadingMoreImages
                    ),
                    title: "Images",
                  },
                  on: { click: _vm.showImagesModal },
                },
                [_c("i", { class: _vm.imagesIcon })]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn-upload btn-remove",
              attrs: {
                disabled: !!(
                  _vm.loadingUpload ||
                  _vm.loadingImages ||
                  _vm.loadingMoreImages
                ),
                title: "Delete",
              },
              on: { click: _vm.removeImage },
            },
            [_c("i", { class: _vm.deleteIcon })]
          ),
          _c("input", {
            ref: "inputFile",
            style: { display: "none" },
            attrs: { type: "file", name: "upload", accept: "image/*" },
            on: {
              change: function ($event) {
                return _vm.uploadFile($event)
              },
            },
          }),
        ]),
        _c(
          "div",
          {
            ref: "splashImages",
            staticClass: "splash-images",
            style: { display: "none" },
            attrs: { "data-id": _vm.dataId },
          },
          [
            _c(
              "div",
              {
                staticClass: "input-container d-flex",
                attrs: { "data-id": _vm.dataId },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query",
                    },
                  ],
                  staticClass: "form-control",
                  style: { flex: "1 1 auto" },
                  attrs: {
                    disabled: !!(
                      _vm.loadingUpload ||
                      _vm.loadingImages ||
                      _vm.loadingMoreImages
                    ),
                    type: "text",
                    placeholder: "Search...",
                    "data-id": _vm.dataId,
                  },
                  domProps: { value: _vm.query },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchImages.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.query = $event.target.value
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn-upload",
                    attrs: {
                      title: "Images",
                      disabled: !!(
                        !_vm.query ||
                        _vm.loadingUpload ||
                        _vm.loadingImages ||
                        _vm.loadingMoreImages
                      ),
                      "data-id": _vm.dataId,
                    },
                    on: { click: _vm.searchImages },
                  },
                  [
                    _c("b-spinner", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingImages,
                          expression: "loadingImages",
                        },
                      ],
                      attrs: { small: "" },
                    }),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loadingImages,
                          expression: "!loadingImages",
                        },
                      ],
                      class: `${_vm.magnifyingIcon} disabled`,
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "list-images", attrs: { "data-id": _vm.dataId } },
              _vm._l(_vm.splashImages, function (img, index) {
                return _c("img", {
                  key: index,
                  attrs: { src: img.urls.regular, "data-id": _vm.dataId },
                  on: {
                    click: function ($event) {
                      return _vm.selectImage(img)
                    },
                  },
                })
              }),
              0
            ),
            _vm.splashImages.length
              ? _c(
                  "div",
                  {
                    staticClass: "text-center pt-3",
                    attrs: { "data-id": _vm.dataId },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "outline-primary",
                          size: "sm",
                          disabled: !!(
                            _vm.loadingUpload ||
                            _vm.loadingImages ||
                            _vm.loadingMoreImages
                          ),
                          "data-id": _vm.dataId,
                        },
                        on: { click: _vm.loadMoreImages },
                      },
                      [
                        _c("b-spinner", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loadingMoreImages,
                              expression: "loadingMoreImages",
                            },
                          ],
                          attrs: { small: "" },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.loadingMoreImages,
                                expression: "!loadingMoreImages",
                              },
                            ],
                            staticClass: "disabled",
                          },
                          [_vm._v("More images")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }